import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/components/Home";
import PrivacyPolicy from "@/components/PrivacyPolicy";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
